/**
 * Mapping for configuration element types to HTML/Vue input types
 * @property {string} checkbox_normal - Maps to 'checkbox'.
 * @property {string} select_normal - Maps to 'select'.
 * @property {string} input_password - Maps to 'password'.
 * @property {string} textarea_normal - Maps to 'textarea'.
 * @property {string} input_hidden - Maps to 'read_only'.
 * @property {string} connection_ending_select - Maps to 'text'.
 * @property {string} login_method_select - Maps to 'text'.
 * @property {string} multihead_select - Maps to 'text'.
 * @property {string} txt - Maps to 'text'.
 * @property {string} input_normal - Maps to 'text'.
 * @property {string} input_file_auto - Maps to 'text'.
 */
const elementTypeToHtmlTypeMap: Record<string, string> = {
  'checkbox_normal': 'checkbox',
  'select_normal': 'select',
  'input_password': 'password',
  'textarea_normal': 'textarea',
  'input_hidden': 'read_only',
  'connection_ending_select': 'text',
  'login_method_select': 'text',
  'multihead_select': 'text',
  'txt': 'text',
  'input_normal': 'text',
  'input_file_auto': 'text',
};

/**
 * Maps configuration element types to HTML/Vue input types
 * @param elementType - The element type from configuration
 * @returns The corresponding HTML input type string, or 'text' if not found
 */
export function mapElementTypeToHtmlType(elementType: string | null): string {
  if (!elementType) return 'text'; // Default for null

  const lowerCaseType = elementType.toLowerCase();
  return elementTypeToHtmlTypeMap[lowerCaseType] || 'text';
}